<template>
  <v-form ref="formEndereco" v-model="enderecoValid" lazy-validation class="mt-4">
    <v-card class="mt-4">
      <v-card-title>
        <strong>{{ !endereco.id ? "Informe seu endereço" : "Endereço" + (impresso ? " de entrega" : " de cobrança") }}</strong>
      </v-card-title>
      <v-card-text>
        <v-divider></v-divider>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex xs12 v-if="endereco.id && impresso">
              <span
                >Seu jornal será entregue no endereço:
                {{
                  endereco.tipo +
                  " " +
                  endereco.logradouro +
                  ", " +
                  endereco.numero +
                  (endereco.complemento ? " - " + endereco.complemento : "") +
                  " - " +
                  endereco.bairro +
                  " - " +
                  endereco.municipio +
                  "/" +
                  endereco.uf +
                  "."
                }}</span
              >
              <br />
              <span>Utilize a aba Meus Dados <v-icon>account_circle</v-icon> quando desejar alterar.</span>
            </v-flex>

            <v-flex xs6 md2 v-if="!endereco.id">
              <v-text-field
                autofocus
                :disabled="isUpdating || idAssinatura != null"
                v-model="endereco.cep"
                label="CEP"
                v-mask="'#####-###'"
                color="blue-grey lighten-2"
                autocomplete="disabled"
                :name="Math.random()"
                @keyup.enter="buscarCep"
                @click:append="buscarCep"
                @keyup="buscarCep"
                append-icon="search"
                hint="Informe o CEP"
                :rules="[validacao.cep == false || validacao.cep, (value) => !!value || 'Obrigatório.', (value) => (value && value.length == 9) || 'CEP Inválido']"
              >
              </v-text-field>
            </v-flex>
            <v-flex xs12 md5 v-if="!endereco.id">
              <v-autocomplete
                disabled
                v-model="endereco.idUF"
                :items="ufs"
                :filter="filtrarUFs"
                hint="Obrigatório"
                :rules="[validacao.idUF == false || validacao.idUF, (value) => !!value || 'Obrigatório.']"
                label="Selecione o Estado"
                item-text="nome"
                item-value="id"
                autocomplete="disabled"
                :name="Math.random()"
                no-data-text="Informe o CEP"
              ></v-autocomplete>
            </v-flex>

            <v-flex xs12 md5 v-if="!endereco.id">
              <v-autocomplete
                disabled
                v-model="endereco.idMunicipio"
                :items="municipios"
                :filter="filtrarObjetos"
                hint="Obrigatório"
                :rules="[validacao.idMunicipio == false || validacao.idMunicipio, (value) => !!value || 'Obrigatório.']"
                label="Selecione o Município"
                item-text="nome"
                item-value="id"
                autocomplete="disabled"
                :name="Math.random()"
                no-data-text="Selecione o Estado"
                @change="validacao.idMunicipio = false"
              ></v-autocomplete>
            </v-flex>

            <v-flex xs12 md10 v-if="!endereco.id && !cepExterno">
              <v-autocomplete
                :disabled="isUpdating || idAssinatura != null"
                v-model="cepSelecionado"
                :items="ceps"
                :filter="filtrarObjetos"
                hint="Obrigatório"
                :rules="[validacao.idCEP == false || validacao.idCEP, (value) => !!value || 'Obrigatório.']"
                label="Selecione o Logradouro"
                item-text="nome"
                item-value="id"
                no-data-text="Informe o CEP e selecione o município"
                autocomplete="disabled"
                :name="Math.random()"
                @change="
                  validacao.idCEP = false;
                  $refs.focusNumero.focus();
                "
                return-object
              ></v-autocomplete>
            </v-flex>

            <v-flex xs12 md12 v-if="!endereco.id && cepExterno">
              <v-text-field
                :disabled="isUpdating || idAssinatura != null"
                v-model="endereco.bairro"
                label="Bairro"
                maxlength="50"
                color="blue-grey lighten-2"
                :rules="[validacao.bairro == false || validacao.bairro, (value) => !!value || 'Obrigatório.']"
                autocomplete="disabled"
                :name="Math.random()"
                @change="
                  validacao.bairro = false;
                  endereco.bairro = pLetra(endereco.bairro);
                "
              ></v-text-field>
            </v-flex>
            <v-flex xs4 md2 v-if="!endereco.id && cepExterno">
              <v-autocomplete
                :disabled="isUpdating || idAssinatura != null"
                v-model="endereco.idTipo"
                :items="tiposLogradouros"
                :filter="filtrarObjetos"
                hint="Obrigatório"
                :rules="[validacao.idTipo == false || validacao.idTipo, (value) => !!value || 'Obrigatório.']"
                label="Selecione o Tipo"
                item-text="nome"
                item-value="id"
                autocomplete="disabled"
                :name="Math.random()"
                @change="validacao.idTipo = false"
              ></v-autocomplete>
            </v-flex>
            <v-flex xs8 md8 v-if="!endereco.id && cepExterno">
              <v-text-field
                :disabled="isUpdating || idAssinatura != null"
                v-model="endereco.logradouro"
                label="Logradouro"
                maxlength="100"
                :rules="[validacao.logradouro == false || validacao.logradouro, (value) => !!value || 'Obrigatório.']"
                color="blue-grey lighten-2"
                autocomplete="disabled"
                :name="Math.random()"
                @change="
                  validacao.logradouro = false;
                  endereco.logradouro = pLetra(endereco.logradouro);
                "
              ></v-text-field>
            </v-flex>

            <v-flex xs12 md2 v-if="!endereco.id">
              <v-text-field
                :disabled="isUpdating || idAssinatura != null"
                v-model="endereco.numero"
                label="Número"
                v-mask="'#####'"
                ref="focusNumero"
                hint="Obrigatório"
                :rules="[validacao.numero == false || validacao.numero, (value) => !!value || 'Obrigatório.', (value) => (value >= 0 && value <= 99999) || 'Obrigatório']"
                color="blue-grey lighten-2"
                autocomplete="disabled"
                :name="Math.random()"
                @change="validacao.numero = false"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 v-if="!endereco.id">
              <v-text-field
                :disabled="isUpdating || idAssinatura != null"
                v-model="endereco.complemento"
                label="Complemento"
                maxlength="100"
                :rules="[validacao.complemento == false || validacao.complemento]"
                color="blue-grey lighten-2"
                autocomplete="disabled"
                :name="Math.random()"
                @change="
                  validacao.complemento = false;
                  endereco.complemento = pLetra(endereco.complemento);
                "
              ></v-text-field>
            </v-flex>
            <v-flex xs12 v-if="!endereco.id && impresso">
              <v-autocomplete
                :disabled="isUpdating || idAssinatura != null"
                v-model="endereco.idModoEntrega"
                :items="modos"
                :filter="filtrarObjetos"
                hint="Obrigatório"
                :rules="[validacao.idModoEntrega == false || validacao.idModoEntrega, (value) => !!value || 'Obrigatório.']"
                label="Modo de Entrega"
                item-text="nome"
                item-value="id"
                no-data-text
                autocomplete="disabled"
                :name="Math.random()"
                @change="validacao.idModoEntrega = false"
              ></v-autocomplete>
            </v-flex>
            <v-flex xs12>
              <v-sheet class="ml-1 red--text" :value="true" v-if="mensagemErro">{{ mensagemErro }}</v-sheet>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
    </v-card>
  </v-form>
</template>

<script>
import axios from "axios";
import { api } from "@/services/api.js";
import util from "../util";
export default {
  props: {
    validacao: {},
    endereco: {},
    isUpdating: { type: Boolean, default: false },
    idAssinatura: { type: Number, default: null },
    impresso: { type: Boolean, default: false }
  },
  data() {
    return {
      cepInvalido: false,
      cepSelecionado: {},
      cepExterno: false,
      ufs: [],
      municipios: [],
      ceps: [],
      tiposLogradouros: [],
      modos: [],

      mensagemErro: "",
      enderecoValid: true
    };
  },
  methods: {
    async carregarUFs() {
      this.ufs = [];
      try {
        const response = await api.get("/ass/paywall/ufs");
        this.ufs = response.data;
      } catch (e) {
        this.mensagemErro =
          "ERRO: " +
          (e.toString().includes("status code 400")
            ? "SESSÃO EXPIRADA"
            : e.response && e.response.data && e.response.data.length > 0
            ? e.response.data[0].mensagem
            : "Indeterminado, verifique sua conexão");
      }
    },
    async carregarMunicipios() {
      this.municipios = [];
      if (this.endereco.idUF) {
        try {
          //* Carrega os municípios da UF
          const response = await api.get("/ass/paywall/municipios?idUF=" + this.endereco.idUF);
          this.municipios = response.data;
          this.cepExterno = false;
        } catch (e) {
          this.mensagemErro =
            "ERRO: " +
            (e.toString().includes("status code 400")
              ? "SESSÃO EXPIRADA"
              : e.response && e.response.data && e.response.data.length > 0
              ? e.response.data[0].mensagem
              : "Indeterminado, verifique sua conexão");
        }
      }
    },
    async carregarMunicipiosIBGE(ibge) {
      this.municipios = [];
      try {
        //* Carrega os municípios da UF
        const response = await api.get("/ass/paywall/municipio/ibge/" + ibge);
        this.municipios = response.data;
        this.cepExterno = true;
      } catch (e) {
        this.mensagemErro =
          "ERRO: " +
          (e.toString().includes("status code 400")
            ? "SESSÃO EXPIRADA"
            : e.response && e.response.data && e.response.data.length > 0
            ? e.response.data[0].mensagem
            : "Indeterminado, verifique sua conexão");
      }
    },
    async carregarTiposLogradouros() {
      this.tiposLogradouros = [];
      try {
        const response = await api.get("/ass/paywall/tipos-logradouro");
        this.tiposLogradouros = response.data;
      } catch (e) {
        this.mensagemErro =
          "ERRO: " +
          (e.toString().includes("status code 400")
            ? "SESSÃO EXPIRADA"
            : e.response && e.response.data && e.response.data.length > 0
            ? e.response.data[0].mensagem
            : "Indeterminado, verifique sua conexão");
      }
    },
    async carregarModos() {
      try {
        //* Carrega os modos de entrega
        const response = await api.get("/ass/paywall/modos-entrega");
        this.modos = response.data;
      } catch (e) {
        this.mensagemErro =
          "ERRO: " +
          (e.toString().includes("status code 400")
            ? "SESSÃO EXPIRADA"
            : e.response && e.response.data && e.response.data.length > 0
            ? e.response.data[0].mensagem
            : "Indeterminado, verifique sua conexão");
      }
    },

    async buscarCep() {
      if (this.endereco.cep != null && this.endereco.cep.length == 9) {
        this.validacao.cep = false;
        this.cepInvalido = false;
        this.ceps = [];

        try {
          //* Carrega os logradouros com o CEP
          var cep = util.somenteNumeros(this.endereco.cep);
          const response = await api.get("/ass/paywall/cep/" + cep + (this.impresso ? "?entrega=1" + (this.$store.state.site.paywallValidarRota ? "&rota=1" : "") : ""));

          if (this.impresso && this.$store.state.site.paywallValidarRota) {
            if (!response.data.length) {
              this.validacao.cep = "Este endereço não possui rota de entrega";
              this.cepInvalido = "Este endereço não possui rota de entrega";
              return;
            }
          }

          this.ceps = response.data;
          this.ceps.forEach((element) => {
            element.nome = element.cep + ": " + element.bairro + " - " + element.tipo + " " + element.logradouro;
          });

          var cep0 = this.ceps.length ? this.ceps[0] : null;
          if (cep0) {
            this.endereco.idUF = cep0.idUF;
            this.endereco.uf = cep0.uf;
            this.endereco.idMunicipio = cep0.idMunicipio;
            this.endereco.municipio = cep0.municipio;
            await this.carregarMunicipios();
            if (this.ceps.length == 1) {
              this.cepSelecionado = cep0;
            }
          } else {
            if (!this.impresso || !this.$store.state.site.paywallValidarRota) {
              //* Busca na base externa para incluir
              this.cepSelecionado = {};
              await this.buscarCepExterno();
            } else {
              this.validacao.cep = "Este endereço não possui rota de entrega";
              this.cepInvalido = "Este endereço não possui rota de entrega";
            }
          }
        } catch (e) {
          this.mensagemErro =
            "ERRO: " +
            (e.toString().includes("status code 400")
              ? "SESSÃO EXPIRADA"
              : e.response && e.response.data && e.response.data.length > 0
              ? e.response.data[0].mensagem
              : "Indeterminado, verifique sua conexão");
        }
      }
    },

    async buscarCepExterno() {
      try {
        var nroCep = util.somenteNumeros(this.endereco.cep);
        //* Busca o cep no webservice gratuito, tem que ser axios, senão dá erro crossorigin
        const response = await axios.get("https://viacep.com.br/ws/" + nroCep + "/json/");

        var cep = response.data;
        if (cep.erro) {
          this.validacao.cep = "CEP não localizado";
          this.cepInvalido = "CEP não localizado";
        } else {
          try {
            //* Busca o município pelo código IBGE
            await this.carregarMunicipiosIBGE(cep.ibge);
            if (this.municipios.length) {
              this.endereco.idUF = this.municipios[0].idUF;
              this.endereco.uf = this.municipios[0].uf;
              this.endereco.idMunicipio = this.municipios[0].id;
              this.endereco.municipio = this.municipios[0].nome;

              //Precisei carregar de novo para setar no select
              const cidades = this.municipios;
              this.municipios = [];
              this.municipios = cidades;

              var tipoLogr = cep.logradouro.split(" ")[0];
              var logradouro = "";
              var itemTipo = this.tiposLogradouros.find((tipo) => tipo.nome == tipoLogr);
              if (!itemTipo) {
                if (tipoLogr.startsWith("S") || tipoLogr.startsWith("Q")) {
                  itemTipo = this.tiposLogradouros.find((tipo) => tipo.nome == "Setor");
                } else {
                  itemTipo = this.tiposLogradouros.find((tipo) => tipo.nome == "Rua");
                }
                logradouro = cep.logradouro;
              } else {
                logradouro = cep.logradouro.substring(tipoLogr.length + 1);
              }

              this.endereco.bairro = cep.bairro;
              this.endereco.idTipo = itemTipo.id;
              this.endereco.tipo = itemTipo.nome;
              this.endereco.logradouro = logradouro;
            }
          } catch (e) {
            console.log(e);
          }
        }
      } catch (e) {
        console.log(e);
      }
    },

    validar() {
      this.$refs.formEndereco.validate();
    },
    retornaEndereco() {
      if (this.cepInvalido) {
        this.validacao.cep = this.cepInvalido;
      }
      if (!this.$refs.formEndereco.validate() || this.cepInvalido) {
        return {};
      } else {
        var itemTipo = this.tiposLogradouros.find((tipo) => tipo.id == this.endereco.idTipo);
        this.endereco.tipo = itemTipo.nome;
        this.endereco.cep = util.somenteNumeros(this.endereco.cep);
        if (this.endereco.bairro) {
          this.endereco.bairro = this.pLetra(this.endereco.bairro);
        }
        if (this.endereco.logradouro) {
          this.endereco.logradouro = this.pLetra(this.endereco.logradouro);
        }
        if (this.endereco.complemento) {
          this.endereco.complemento = this.pLetra(this.endereco.complemento);
        }
        return this.endereco;
      }
    },

    pLetra(text) {
      text = util.removeSomenteEspeciais(text);
      return util.pLetra(text);
    },
    filtrarObjetos(item, queryText, itemText) {
      return util.filtrarObjetos(item, queryText, itemText);
    },
    filtrarUFs(item, queryText, itemText) {
      return util.filtrarUFs(item, queryText, itemText);
    }
  },

  watch: {
    cepSelecionado(val) {
      if (val) {
        this.endereco.idCEP = val.id;
        this.endereco.bairro = val.bairro;
        this.endereco.idTipo = val.idTipo; //itemTipo.id;
        this.endereco.tipo = val.tipo; //itemTipo.nome;
        this.endereco.logradouro = val.logradouro;
      }
    }
  },

  async created() {
    await this.carregarUFs();
    await this.carregarTiposLogradouros();
    await this.carregarModos();

    setTimeout(() => {
      var patio = this.modos.find((item) => util.removeAcentos(item.nome) == "Patio");
      if (patio) {
        this.endereco.idModoEntrega = patio.id;
      } else {
        this.endereco.idModoEntrega = 1;
      }
    }, 300);
  }
};
</script>
